export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS'
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE'

export const SEND_MESSAGE = 'SEND_MESSAGE'
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS'
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE'


export const fetchProduct = (id) => ({
    type: FETCH_PRODUCT,
    payload: id
})

export const fetchProductSuccess = (product) => ({
    type: FETCH_PRODUCT_SUCCESS,
    payload: product
})

export const fetchProductFailed = (message) => ({
    type: FETCH_PRODUCT_FAILURE,
    payload: message
})


export const sendMessage = (id) => ({
    type: SEND_MESSAGE,
    payload: id
})

export const sendMessageSuccess = (message) => ({
    type: SEND_MESSAGE_SUCCESS,
    payload: message
})

export const sendMessageFailed = (message) => ({
    type: SEND_MESSAGE_FAILURE,
    payload: message
})

